import { Report1918Container } from "../../../containers/borrowSystem/Report/Report1918Container";

export function Report1918Page() {
    return (
        <Report1918Container />
    )
}